const n = (v) => (v === "" || v == null || isNaN(Number(v)) ? null : Number(v));
const base = (u) => (u === "mg" ? { k: "mass", f: 1000 } : u === "mcg" ? { k: "mass", f: 1 } : u === "units" ? { k: "units", f: 1 } : null);

// Returns infusion rate in mL/h, or null if not computable.
export function infusionRate(inf, weightKg, doseOverride) {
  if (!inf) return null;
  const dose = n(doseOverride ?? inf.dose);
  const [amt, ...rest] = String(inf.dose_unit || "").split("/");
  const perKg = rest.includes("kg");
  const perMin = rest.includes("min");
  const d = base(amt), c = base(inf.conc_unit);
  const vol = n(inf.conc_volume_ml), cAmt = n(inf.conc_amount), w = n(weightKg);
  if (dose == null || !d || !c || d.k !== c.k || !vol || !cAmt || (perKg && !w)) return null;
  const perHour = dose * d.f * (perKg ? w : 1) * (perMin ? 60 : 1);
  const conc = (cAmt * c.f) / vol;
  return +(perHour / conc).toFixed(1);
}

export const concLabel = (inf) => (inf ? `${inf.conc_amount} ${inf.conc_unit} in ${inf.conc_volume_ml} mL` : "");
